import { createAction } from 'redux-act';
import { IChip } from '@alycecom/ui';

import { IFilters } from '../../../store/products/products.types';

export const setFilter = createAction<{ key: keyof IFilters; items: number[] }>('SET_FILTER');
export const setSearch = createAction<string>('SET_SEARCH');
export const setSorting = createAction<number>('SET_SORTING');
export const toggleTab = createAction<{ name: string; isOpen: boolean }>('TOGGLE_TAB');
export const addChip = createAction<IChip>('ADD_CHIP');
export const deleteChip = createAction<IChip>('DELETE_CHIP');
